import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

import { Container, Content, Title, Description, Separator, Route } from "./styles";

export const NavBar = ({ title, description }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isAuthenticated } = useSelector((state) => state.userReducer);

  return (
    <Container>
      <Content>
        <Title>{t(title)}</Title>

        <Separator />

        <div>
          <Description>{t(description)}</Description>
          {isAuthenticated ? (
            <Route>
              <p onClick={() => navigate(-2)}>{t("PERSONAL_INFO")}</p>
              <FaAngleRight size={16} color={"#fff"} />
              <p onClick={() => navigate(-1)}>{t("PLANS")}</p>
              <FaAngleRight size={16} color={"#fff"} /> {t(title)}
            </Route>
          ) : (
            <Route>
              {title === "Checkout" ? (
                <a rel="noreferrer" href="https://www.lingofor.me/lingo-us/lingo_plans.html" target="_top">
                  {t("PLANS_AND_PRICING")}
                </a>
              ) : (
                <a rel="noreferrer" href="https://www.lingofor.me/lingo-us/" target="_top">
                  Home
                </a>
              )}
              <FaAngleRight size={16} color={"#fff"} /> {t(title)}
            </Route>
          )}
        </div>
      </Content>
    </Container>
  );
};

export default NavBar;
